<template>
  <router-view />
</template>
<script>
export default {
  name: 'ProductOperateIndex',
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/product/operate/Index.vue